/**
 * downloadCsv — thin wrapper that:
 *   1. Calls the given endpoint via the shared axios client (so it
 *      picks up the admin's Bearer token automatically).
 *   2. Materialises the CSV bytes as a Blob.
 *   3. Triggers a save-as with the provided filename.
 *
 * Kept in /lib so both the Vendors and Customers admin pages share the
 * exact same download plumbing.
 */
import { toast } from "sonner";
import { client } from "@/lib/api";

export async function downloadCsv({ url, params, filename }) {
  try {
    const r = await client.get(url, {
      params,
      responseType: "blob",
    });
    const blob = new Blob([r.data], { type: "text/csv;charset=utf-8;" });
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename || "export.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 500);
    return true;
  } catch (err) {
    const msg =
      err?.response?.status === 403
        ? "Super Admin access required for CSV export."
        : err?.response?.data?.detail || "Couldn't export CSV. Please try again.";
    toast.error(msg);
    return false;
  }
}
